import { ServiceIdentifier } from '../service-locator';
import { StrategyService } from './interfaces';

export * from './interfaces';

export const STRATEGY_SERVICE = ServiceIdentifier.get<StrategyService>('StrategyService');
